import { Box, Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  CmpButton,
  CmpDatePicker,
  CmpSelectBox,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { useSelector } from "react-redux";
import { GetGitterColumns } from "../../Utility/Utilitys";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import moment from "moment";
import {
    common_DispatchDetail_Attributes,
  common_DispatchDetail_GETROW,
  common_InboundProcessFlow_GETROW,
} from "../../Server/ApiV2";

const DispatchDetails = () => {
  const LocFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value); 

  const [truckData, setTruckData] = useState([]);
  const [statusData, setstatusData] = useState([
    { uid: "All", name: "All" },
    { uid: "Enter", name: "Enter" },
    { uid: "Post", name: "Post" },
  ]);

  const [summaryObj, setSummaryObj] = useState({
    loc: vRdxuserLoc[0]?.UID,
    fromDate: new Date(),
    toDate: new Date(),
    truck: "All",
    status: "All",
  });
  const [sGridrows, setGridrows] = useState([]);

  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

const GetTruckArray = async () => {
    const truckArrayList = await common_DispatchDetail_Attributes();
    if(truckArrayList.status === 200) {
        setTruckData(truckArrayList.data.ResultSet.Truck)
    }
}

  const fLoad = () => {
    GetSummaryList();
  };

  const GetSummaryList = async () => {
    let vSummaryListObj = {
      v_Loc: summaryObj.loc == "" ? vRdxuserLoc[0]?.UID : summaryObj.loc,
      v_Date1: moment(summaryObj.fromDate).format("MM/DD/YYYY"),
      v_Date2: moment(summaryObj.toDate).format("MM/DD/YYYY"),
      Truck: summaryObj.truck,
      status: summaryObj.status,
    };
    const vSummaryList = await common_DispatchDetail_GETROW(vSummaryListObj);
    if (vSummaryList.status == 200) {
      let GridID =
        vSummaryList.data.ResultSet.length == 0
          ? []
          : vSummaryList.data.ResultSet?.map((obj, i) => ({
              ...obj,
              id: i + 1,
            }));
      setGridrows(GridID);
    } else {
      setGridrows([]);
    }
  };


  const [Gridcolumns, setGridcolumns] = useState([
    {
      "field": "VocTyp",
      "headerName": "Voc.Type",
      "hide": false,
      "width": 100,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "VocNo",
      "headerName": "Voc.No",
      "hide": false,
      "width": 100,
      "align": "right",
      "headerAlign": "right"
    },
    {
      "field": "TruckId",
      "headerName": "Truck.ID",
      "hide": false,
      "width": 70,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "TruckName",
      "headerName": "Truck.Name",
      "hide": false,
      "width": 100,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "DriverID",
      "headerName": "Driver.ID",
      "hide": false,
      "width": 70,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "DriverName",
      "headerName": "Driver.Name",
      "hide": false,
      "width": 180,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "Date",
      "headerName": "Date",
      "hide": false,
      "width": 100,
      "align": "center",
      "headerAlign": "center"
    },
    {
      "field": "RefDocNo",
      "headerName": "Ref.Doc.No",
      "hide": false,
      "width": 80,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "ItmCd",
      "headerName": "Item.Code",
      "hide": true,
      "width": 90,
      "align": "right",
      "headerAlign": "right"
    },
    {
      "field": "ItmName",
      "headerName": "Item.Name",
      "hide": false,
      "width": 300,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "SuppRefNo1",
      "headerName": "Supp.Ref.No1",
      "hide": false,
      "width": 100,
      "align": "left",
      "headerAlign": "left"
    },
    {
      "field": "BaseQty",
      "headerName": "Base.Qty",
      "hide": false,
      "width": 70,
      "align": "right",
      "headerAlign": "right"
    },
    {
      "field": "Drop_ID",
      "headerName": "Drop.ID",
      "hide": false,
      "width": 100,
      "align": "left",
      "headerAlign": "left"
    }
  ])

  useEffect(() => {
    GetGitterColumns(setGridcolumns, "WMINV08_DISPATCH_DETAILS_COLUMN", Gridcolumns);
    GetTruckArray();

    fLoad();
    LocFocusOnLoad.current?.focus();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="">
        <CmpTypographyField
          xcomponent={"h1"}
          xText={"Dispatch Details"}
          xfontSize="20px"
          xtextDecoration="underline"
        />
      </div>
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center mt-4"
        >
          <Grid item lg={2} md={2} xs={6}>
            <CmpSelectBox
              xLabelText="Location"
              xValue={
                summaryObj.loc === "" ? vRdxuserLoc[0]?.UID : summaryObj.loc
              }
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={vRdxuserLoc}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={summaryObj.fromDate}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  fromDate: newValue.$d,
                }));
              }}
              xName={"fromDate"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={summaryObj?.toDate}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  toDate: newValue.$d,
                }));
              }}
              xName={"toDate"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={6}>
            <CmpSelectBox
              xLabelText="Truck Status"
              xValue={summaryObj.truck}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"truck"}
              xData={truckData}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={6}>
            <CmpSelectBox
              xLabelText="Status"
              xValue={summaryObj?.status}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"status"}
              xData={statusData}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={2} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid>

        <Box
          sx={{ height: vMediaQuery ? "60vh" : "70vh", width: "100%" }}
          className="bin-transfer-data"
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={Gridcolumns}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            hideFooter={sGridrows.length < 100}
            components={{
              Toolbar: vMediaQuery ? "" : GridToolbar,
            }}
            // onRowClick={fOnRowClick}
          />
        </Box>
      </div>
    </div>
  );
};

export default DispatchDetails;
